export { default } from "./UndoIcon";
